import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { ResourceSelector } from "./resourceSelector";
const GetEntityId = (entity) => entity.uniqueId.toString();
/**
 * A generic primitive component with a ComboBox for selecting from a list of entities.
 * Supports entities with duplicate names by using uniqueId for identity.
 * @param props ChooseEntityProps
 * @returns EntitySelector component
 */
export function EntitySelector(props) {
    const { value, onLink, getEntities, getName, filter, defaultValue, disabled } = props;
    const onChange = props.onChange;
    const filterEntity = useCallback((entity) => entity.uniqueId !== undefined && (!filter || filter(entity)), [filter]);
    return (_jsx(ResourceSelector, { value: value, getEntities: getEntities, getName: getName, getId: GetEntityId, filter: filterEntity, onSelect: onChange, onClear: onChange && defaultValue !== undefined ? () => onChange(defaultValue) : undefined, onLink: onLink, disabled: disabled, showEmptySelector: true }));
}
EntitySelector.displayName = "EntitySelector";
//# sourceMappingURL=entitySelector.js.map